import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const YoungEngineersAward2025 = () => {
    const workshopImages = [
        "IMG-20250915-WA0035.jpg ",
        "IMG-20250915-WA0037.jpg ",
        "IMG-20250915-WA0041.jpg ",
        "IMG-20250915-WA0042.jpg ",
        "IMG-20250915-WA0048.jpg ",
        "IMG-20250916-WA0020.jpg",
    ];
    
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        Recognizing Future Leaders: The Young Engineers Award

                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            Every year on Engineers Day (September 15th), we host the prestigious Young Engineers Award ceremony. This event highlights the best and brightest students across all engineering disciplines, celebrating their success in academics alongside their commitment to co-curricular and extra-curricular activities. The Principal, Deans, and Heads of Departments took great pride in felicitating these students and applauding their exceptional performance.                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Young-Engineer-Awards-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Young-Engineer-Awards-2025/${img}`}
                                                            alt={`Young Engineer Awards 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default YoungEngineersAward2025;
